import { FilterContentItem } from './filterModal';

export const customerForecastFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'CUSTOMER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '販売担当者',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },

  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },

  {
    filterType: 'CUSTOMER_CODE',
    selectedValue: [],
    label: '売上先CD',
  },

  {
    filterType: 'CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },

  {
    filterType: 'SALES_DESTINATION_CODE',
    selectedValue: [],
    label: '送り先CD',
  },

  {
    filterType: 'SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },
];

export const supplierForecastFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },

  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  // STOPSHIP: baseTableContentの展開機能を実装したら、以下のコメントを外す
  // {
  //   filterType: 'CUSTOMER_CODE',
  //   selectedValue: [],
  //   label: '売上先CD',g
  // },

  // {
  //   filterType: 'CUSTOMER_NAME',
  //   selectedValue: [],
  //   label: '売上先名',
  // },

  // {
  //   filterType: 'SALES_DESTINATION_CODE',
  //   selectedValue: [],
  //   label: '送り先CD',
  // },

  // {
  //   filterType: 'SALES_DESTINATION_NAME',
  //   selectedValue: [],
  //   label: '送り先名',
  // },
];

export const orderFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'ORDER_ID',
    selectedValue: [],
    label: '取引ID',
  },
  {
    filterType: 'ORDER_DATE',
    selectedValue: [],
    label: '発注日',
    includeNull: false,
  },
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },
  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'DESIRED_DELIVERY_DATE',
    selectedValue: [],
    label: '希望納期',
    includeNull: false,
  },
  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },
  {
    filterType: 'ORDER_NUMBER',
    selectedValue: [],
    label: '発注番号',
  },
  {
    filterType: 'DELIVERY_DATE',
    selectedValue: [],
    label: '納期',
    includeNull: false,
  },
  {
    filterType: 'ORDER_AMOUNT',
    selectedValue: [],
    label: '発注数量',
  },
  {
    filterType: 'ORDER_GROUP_NAME',
    selectedValue: [],
    label: '発注グループ名',
  },
  {
    filterType: 'INVOICE_NUMBER',
    selectedValue: [],
    label: 'インボイス番号',
  },
  {
    filterType: 'DESTINATION_NAME',
    selectedValue: [],
    label: '仕向地',
  },
  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
  { filterType: 'AGGREGATE_FREE_COLUMN', selectedValue: [], label: '' },
];

export const orderCalendarFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'ORDER_ID',
    selectedValue: [],
    label: '取引ID',
  },
  {
    filterType: 'ORDER_DATE',
    selectedValue: [],
    label: '発注日',
    includeNull: false,
  },
  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },
  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'DESIRED_DELIVERY_DATE',
    selectedValue: [],
    label: '希望納期',
    includeNull: false,
  },
  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },
  {
    filterType: 'ORDER_NUMBER',
    selectedValue: [],
    label: '発注番号',
  },
  {
    filterType: 'DELIVERY_DATE',
    selectedValue: [],
    label: '納期',
    includeNull: false,
  },
  {
    filterType: 'ORDER_AMOUNT',
    selectedValue: [],
    label: '発注数量',
  },
  {
    filterType: 'INVOICE_NUMBER',
    selectedValue: [],
    label: 'インボイス番号',
  },
  {
    filterType: 'DESTINATION_NAME',
    selectedValue: [],
    label: '仕向地',
  },
  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
];

export const inventoryFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },

  {
    filterType: 'LEAD_TIME',
    selectedValue: [],
    label: 'リードタイム',
  },

  {
    filterType: 'STANDARD_INVENTORY_INDEX_MIN',
    selectedValue: [],
    label: '標準在庫指数(min)',
  },

  {
    filterType: 'STANDARD_INVENTORY_INDEX_MAX',
    selectedValue: [],
    label: '標準在庫指数(max)',
  },

  {
    filterType: 'CUSTOMER_CODE',
    selectedValue: [],
    label: '売上先CD',
  },

  {
    filterType: 'CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },

  {
    filterType: 'SALES_DESTINATION_CODE',
    selectedValue: [],
    label: '送り先CD',
  },

  {
    filterType: 'SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },

  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },

  {
    filterType: 'CUSTOMER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '販売担当者',
  },
  {
    filterType: 'ORDER_PACKAGE',
    selectedValue: [],
    label: '発注単位',
  },
  {
    filterType: 'AGGREGATE_BUSINESS_GROUP_FILTER_INFO',
    selectedValue: [],
    label: 'グループ',
  },
  {
    filterType: 'PURCHASE_UNIT_PRICE',
    selectedValue: [],
    label: '仕入単価',
  },
  {
    filterType: 'SALES_UNIT_PRICE',
    selectedValue: [],
    label: '販売単価',
  },
  { filterType: 'AGGREGATE_FREE_COLUMN', selectedValue: [], label: '' },
  { filterType: 'BASE_FREE_COLUMN', selectedValue: [], label: '' },
];

// TODO: 実際のフィルターの内容は吟味する必要あり、とりあえずお隣の在庫管理の項目コピーしてるだけ
export const orderControlFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  // NOTE: 以下は期間選択機能を実装しないと使えないので、一旦コメントアウト
  // {
  //   filterType: 'ORDER_DATE',
  //   selectedValue: [],
  //   label: '発注日',
  // },
  // {
  //   filterType: 'ORDER_AMOUNT',
  //   selectedValue: [],
  //   label: '発注数量',
  // },
  // {
  //   filterType: 'DESIRED_DELIVERY_DATE',
  //   selectedValue: [],
  //   label: '希望納期',
  // },
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },

  {
    filterType: 'LEAD_TIME',
    selectedValue: [],
    label: 'リードタイム',
  },

  {
    filterType: 'STANDARD_INVENTORY_INDEX_MIN',
    selectedValue: [],
    label: '標準在庫指数(min)',
  },

  {
    filterType: 'STANDARD_INVENTORY_INDEX_MAX',
    selectedValue: [],
    label: '標準在庫指数(max)',
  },

  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
  {
    filterType: 'LAST_CHECKED_AT',
    selectedValue: [],
    label: 'OrderControlLastCheckedAt',
    includeNull: false,
  },

  // NOTE: 以下は展開機能を実装しないと使えないので、一旦コメントアウト
  // {
  //   filterType: 'CUSTOMER_NAME',
  //   selectedValue: [],
  //   label: '売上先名',
  // },

  // {
  //   filterType: 'SALES_DESTINATION_NAME',
  //   selectedValue: [],
  //   label: '送り先名',
  // },

  // {
  //   filterType: 'CUSTOMER_FORECAST_RESPONSIBLE_USER',
  //   selectedValue: [],
  //   label: '販売担当者',
  // },
  { filterType: 'AGGREGATE_FREE_COLUMN', selectedValue: [], label: '' },
];

export const deletionBusinessFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'UNIT',
    selectedValue: [],
    label: '単位',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },

  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
];

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth() + 1;
const nextYear = currentMonth === 12 ? currentYear + 1 : currentYear;
const nextMonth = currentMonth === 12 ? 1 : currentMonth + 1;
const nextNextYear = nextMonth === 12 ? nextYear + 1 : nextYear;
const nextNextMonth = nextMonth === 12 ? 1 : nextMonth + 1;

export const unmanagedBusinessTypeAnnounceFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-1',
    selectedValue: [],
    label: '年月付き内示',
    i18nOptions: {
      year: currentYear.toString(),
      month: currentMonth.toString(),
    },
  },
  {
    filterType: 'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-2',
    selectedValue: [],
    label: '年月付き内示',
    i18nOptions: {
      year: nextYear.toString(),
      month: nextMonth.toString(),
    },
  },
  {
    filterType: 'UNMANAGED_BUSINESS_ANNOUNCE_AMOUNT-3',
    selectedValue: [],
    label: '年月付き内示',
    i18nOptions: {
      year: nextNextYear.toString(),
      month: nextNextMonth.toString(),
    },
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NUMBER',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NUMBER',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_PACKAGE',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE_NUMBER',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_CUSTOMER_NUMBER',
    selectedValue: [],
    label: '売上先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SALES_DESTINATION_NUMBER',
    selectedValue: [],
    label: '送り先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },
];

export const unmanagedBusinessTypeSalesResultFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'UNMANAGED_BUSINESS_SALES_RESULTS_AMOUNT',
    selectedValue: [],
    label: '販売実績数量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NUMBER',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NUMBER',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_PACKAGE',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE_NUMBER',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_CUSTOMER_NUMBER',
    selectedValue: [],
    label: '売上先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SALES_DESTINATION_NUMBER',
    selectedValue: [],
    label: '送り先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },
];

export const unmanagedBusinessTypeInventoryFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'UNMANAGED_BUSINESS_INVENTORY_AMOUNT',
    selectedValue: [],
    label: '在庫数量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NUMBER',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NUMBER',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_PACKAGE',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE_NUMBER',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
];

export const unmanagedBusinessTypeArrivalFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'UNMANAGED_BUSINESS_ARRIVAL_AMOUNT',
    selectedValue: [],
    label: '入荷数量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NUMBER',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NUMBER',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_PACKAGE',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE_NUMBER',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'UNMANAGED_BUSINESS_WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
];

export const inventoryDashboardFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
  {
    filterType: 'CUSTOMER_CODE',
    selectedValue: [],
    label: '売上先CD',
  },
  {
    filterType: 'CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },
  {
    filterType: 'SALES_DESTINATION_CODE',
    selectedValue: [],
    label: '送り先CD',
  },
  {
    filterType: 'SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },
  {
    filterType: 'END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },
  {
    filterType: 'CUSTOMER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '販売担当者',
  },
];

export const inventoryDashboardDetailAggFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },

  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },

  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },

  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },

  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },

  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },

  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },

  {
    filterType: 'MANUFACTURER',
    selectedValue: [],
    label: '製造社',
  },

  {
    filterType: 'SUPPLIER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '仕入担当者',
  },
];

export const unmatchedOrderFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'UNMATCHED_WAREHOUSE_NUMBER',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'UNMATCHED_WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
  {
    filterType: 'UNMATCHED_SUPPLIER_NUMBER',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'UNMATCHED_SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'UNMATCHED_BUSINESS_NUMBER',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'UNMATCHED_BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'UNMATCHED_ORDER_NUMBER',
    selectedValue: [],
    label: '発注番号',
  },
  {
    filterType: 'UNMATCHED_ORDER_ISSUED_NUMBER',
    selectedValue: [],
    label: '発注管理番号',
  },
];

export const inventoryDashboardDetailBaseFilterItems: ReadonlyArray<Readonly<FilterContentItem>> = [
  {
    filterType: 'WAREHOUSE_CODE',
    selectedValue: [],
    label: '置場CD',
  },
  {
    filterType: 'WAREHOUSE',
    selectedValue: [],
    label: '置場名',
  },
  {
    filterType: 'SUPPLIER_CODE',
    selectedValue: [],
    label: '仕入先CD',
  },
  {
    filterType: 'SUPPLIER_NAME',
    selectedValue: [],
    label: '仕入先名',
  },
  {
    filterType: 'BUSINESS_CODE',
    selectedValue: [],
    label: '商品CD',
  },
  {
    filterType: 'BUSINESS_NAME',
    selectedValue: [],
    label: '商品名',
  },
  {
    filterType: 'PACKAGE_AMOUNT',
    selectedValue: [],
    label: '容量',
  },
  {
    filterType: 'CUSTOMER_CODE',
    selectedValue: [],
    label: '売上先CD',
  },
  {
    filterType: 'CUSTOMER_NAME',
    selectedValue: [],
    label: '売上先名',
  },
  {
    filterType: 'SALES_DESTINATION_CODE',
    selectedValue: [],
    label: '送り先CD',
  },
  {
    filterType: 'SALES_DESTINATION_NAME',
    selectedValue: [],
    label: '送り先名',
  },
  {
    filterType: 'END_USER',
    selectedValue: [],
    label: 'エンドユーザー',
  },
  {
    filterType: 'CUSTOMER_FORECAST_RESPONSIBLE_USER',
    selectedValue: [],
    label: '販売担当者',
  },
  {
    filterType: 'FORECAST_FOR_RECEIPT_NAME',
    selectedValue: [],
    label: '受領用内示名',
  },
  {
    filterType: 'FORECAST_FOR_RECEIPT_RESPONSIBLE_USER',
    selectedValue: [],
    label: '受領用内示担当者',
  },
];
